import React, { useEffect, useState } from 'react';
import { useSiteState } from '../../state/state';
import { Spacer } from '../common/Spacer';
import { SummaryBlock } from '../common/SummaryBlock';
import { ActionButton } from '../common/ActionButton';
import { Col, Form, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { CheckinForm } from '../../service/checkin-flow';
import { ContactData } from '../../model/Model';

type ContactsStepProps = {
    buttonText: string,
    buttonLoadingText: string,
    buttonLoading: boolean,
    onStepComplete: (form: CheckinForm) => void,
    contacts?: ContactData[]
}

export const ContactsStep = ({
                                 buttonText,
                                 buttonLoadingText,
                                 buttonLoading,
                                 onStepComplete,
                                 contacts,
                             }: ContactsStepProps) => {

    const { settings } = useSiteState();
    const { control, handleSubmit, watch } = useForm<CheckinForm>();
    const selectedContact = watch('contact');

    const [buttonDisabled, setButtonDisabled] = useState(true);

    useEffect(() => {
        if ((selectedContact && selectedContact > 0) || settings?.siteContactsSelect) {
            setButtonDisabled(false);
        } else {
            setButtonDisabled(true);
        }
    }, [selectedContact]);

    return (
        <>
            <form onSubmit={handleSubmit(onStepComplete)}>
                <Spacer height='2em' />
                <SummaryBlock display className='summary-block'>
                    <Row>
                        <Col className="px-0">
                            <Controller
                                name='contact'
                                control={control}
                                defaultValue={0}
                                render={({ onChange }) => (
                                    <Form.Group>
                                        <Form.Label className="med-heading">{settings?.siteContactsLabel ? settings?.siteContactsLabel : 'Contact'}</Form.Label>
                                        <Form.Control as="select" onChange={(e) => onChange(+e.target.value)} defaultValue={settings?.siteContactsSelect}>
                                            <option key='opt_instr' value={0}>
                                                Please select site contact
                                            </option>
                                            {contacts ? contacts.map(c => (
                                                <option key={`opt_${c.workerId}`} value={`${c.workerId}`}>
                                                    {c.firstLastName}
                                                </option>)) : null}
                                        </Form.Control>
                                    </Form.Group>
                                )}
                            />
                        </Col>
                    </Row>
                </SummaryBlock>
                <ActionButton text={buttonLoading ? buttonLoadingText : buttonText} disabled={buttonDisabled || buttonLoading} submit />
            </form>
        </>
    )
}
